import React from 'react';

export const ArrowMoveDown = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.66699 2V3.38461C2.66699 4.71857 2.66699 5.38555 2.76388 5.94363C3.29719 9.01567 5.93803 11.4251 9.30526 11.9116C9.91693 12 11.2049 12 12.667 12" stroke="#9CA3AF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.333 14C11.7375 13.6068 13.333 12.5602 13.333 12C13.333 11.4398 11.7375 10.3932 11.333 10" stroke="#9CA3AF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
